import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Before React/Helmet mounts, strip any pre-existing SEO head tags (the raw
// fallback title, plus title/description/canonical injected by the prerender
// layer without react-helmet-async ownership markers). This prevents Helmet
// from appending duplicates when JS renders on top of prerendered HTML.
[
  "head > title",
  'head > meta[name="description"]',
  'head > link[rel="canonical"]',
  'head > meta[property^="og:"]',
  'head > meta[name^="twitter:"]',
  'head > meta[name="robots"]',
].forEach((sel) => document.querySelectorAll(sel).forEach((el) => el.remove()));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
